import api from "./index";
import { BaseURL } from "@/utils/config";
import { axios } from "@/utils/request";

export function getHistoryMaster(parameter) {
    return axios({
        url: BaseURL + api.Master + "get_list_version",
        method: "GET",
        params: parameter,
    });
}

export function getMasterData(parameter) {
    return axios({
        url: BaseURL + api.Master + "list",
        method: "GET",
        params: parameter,
    });
}
export function getRecoveMaintain(parameter) {
    return axios({
        url: BaseURL + api.Master + "get_recover",
        method: "GET",
        params: parameter,
    });
}
export function getListNotification(parameter) {
    return axios({
        url: BaseURL + api.Master + "list_notification",
        method: "GET",
        params: parameter,
    });
}
export function getListNotice(parameter) {
    return axios({
        url: BaseURL + api.Master + "list_notification_hidden",
        method: "GET",
        params: parameter,
    });
}
export function getDetailVersion(parameter) {
    return axios({
        url: BaseURL + api.Master + "detail_version",
        method: "POST",
        data: parameter,
    });
}
export function createRecoveMaintain(parameter) {
    return axios({
        url: BaseURL + api.Master + "create_recover",
        method: "POST",
        data: parameter,
    });
}
export function UpdateSettingChapter(parameter) {
    return axios({
        url: BaseURL + api.Master + "update_settings",
        method: "POST",
        data: parameter,
    });
}
export function createNotification(parameter) {
    return axios({
        url: BaseURL + api.Master + "create_notification",
        method: "POST",
        data: parameter,
    });
}
export function createNotice(parameter) {
    return axios({
        url: BaseURL + api.Master + "publish_notification",
        method: "POST",
        data: parameter,
    });
}

export function deleteNotification(parameter) {
    return axios({
        url: BaseURL + api.Master + "delete_notification",
        method: "POST",
        data: parameter,
    });
}

export function deleteNotice(parameter) {
    return axios({
        url: BaseURL + api.Master + "delete_notification_hidden",
        method: "POST",
        data: parameter,
    });
}
export function updateNotification(parameter) {
    return axios({
        url: BaseURL + api.Master + "update_notification",
        method: "POST",
        data: parameter,
    });
}
export function updateNotice(parameter) {
    return axios({
        url: BaseURL + api.Master + "update_notification_hidden",
        method: "POST",
        data: parameter,
    });
}

export function deleteRecoveMaintain(parameter) {
    return axios({
        url: BaseURL + api.Master + "delete_recover",
        method: "POST",
        data: parameter,
    });
}
export function cancelRecoveMaintain(parameter) {
    return axios({
        url: BaseURL + api.Master + "cancel_recover",
        method: "POST",
        data: parameter,
    });
}

export function updateRecoveMaintain(parameter) {
    return axios({
        url: BaseURL + api.Master + "update_recover",
        method: "POST",
        data: parameter,
    });
}

export function exportData(parameter) {
    return axios({
        url: BaseURL + api.Master + "export_data_section",
        method: "POST",
        data: parameter,
    });
}